import { render, staticRenderFns } from "./RejectionTreatment.vue?vue&type=template&id=5c7e4ef8&scoped=true&"
import script from "./RejectionTreatment.vue?vue&type=script&lang=js&"
export * from "./RejectionTreatment.vue?vue&type=script&lang=js&"
import style0 from "./RejectionTreatment.vue?vue&type=style&index=0&id=5c7e4ef8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e4ef8",
  null
  
)

export default component.exports